module.exports = __webpack_public_path__ + "img/global_default_head@3x.5c4d972d.png";